
import { Box, Container, Paper, Typography } from "@mui/material";

const WHY_COSTLIX = [
  {
    title: "Real-World Benchmarks",
    desc: "Estimates are calculated using production data from real software projects — not generic calculators.",
    icon: "📈",
  },
  {
    title: "Transparent Cost Logic",
    desc: "Every number is derived from scope, complexity, and delivery effort — no hidden assumptions.",
    icon: "🔍",
  },
  {
    title: "Expert-Validated Estimates",
    desc: "Pricing models reviewed by senior architects and delivery leads with hands-on experience.",
    icon: "🛡️",
  },
  {
    title: "Decision-Ready Outputs",
    desc: "Clear ranges and breakdowns that help teams plan budgets confidently before committing.",
    icon: "✅",
  },
];


const WhyCostlix = () => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
          <Typography
            sx={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "var(--color-midnight-60)",
              mb: 0.8,
            }}
          >
            Why Costlix
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 800,
              color: "var(--color-midnight)",
              letterSpacing: "-0.015em",
            }}
          >
            Confident estimates.{" "}
            <Box component="span" sx={{ color: "var(--color-fiery)" }}>
              Clear decisions.
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 1.2,
              maxWidth: 640,
              mx: "auto",
              fontSize: { xs: "0.9rem", md: "1rem" },
              lineHeight: 1.65,
              color: "var(--color-midnight-70)",
            }}
          >
            Costlix helps founders, teams, and decision-makers understand real
            project costs before committing resources.
          </Typography>
        </Box>

        {/* Cards */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2.5, md: 3 },
            mt: { xs: 4, md: 6 },
          }}
        >
          {WHY_COSTLIX.map((item, index) => (
            <Paper
              key={index}
              elevation={0}
              sx={{
                flex: {
                  xs: "1 1 100%", // mobile: 1 per row
                  sm: "1 1 calc(50% - 12px)", // tablet: 2 per row
                  md: "1 1 calc(25% - 18px)", // desktop: 4 per row
                },
                minHeight: 220,
                p: { xs: 2.5, md: 3 },
                borderRadius: 2,
                background:
                  "linear-gradient(180deg, #FFFFFF 0%, rgba(246,247,235,0.9) 100%)",
                border: "1px solid var(--color-midnight-15)",
                transition: "all 0.25s ease",
                display: "flex",
                flexDirection: "column",

                "&:hover": {
                  transform: { md: "translateY(-6px)" },
                  boxShadow: "0 16px 40px rgba(0,0,0,0.08)",
                },
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "14px",
                  mb: 2,
                  backgroundColor: "rgba(233,79,55,0.12)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "1.2rem",
                }}
              >
                {item.icon}
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: "1rem",
                  mb: 0.8,
                  color: "var(--color-midnight)",
                }}
              >
                {item.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  lineHeight: 1.6,
                  color: "var(--color-midnight-70)",
                }}
              >
                {item.desc}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default WhyCostlix;
